import { defineComponent as _defineComponent } from 'vue'
import { store } from '@/store';
import { computed, onUpdated, ref } from 'vue';
import {  ProductProperty } from './product-properties';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductColorPicker',
  props: {
    colors: { default: () => [] },
    value: { default: null },
    animateAutoChange: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as { colors: IColorOption[], value: string, animateAutoChange?: boolean }



const selectedColor = ref<IColorOption>(null);
const selectedColorText = ref<string>('');
const intendedColorChangeText = ref<string>('');

const product = computed<ProductBaseViewModel<VariantBaseViewObject>>(() => store.getters['catalog/product']);
const selectedVariant = computed<VariantBaseViewObject>(() => store.getters['catalog/selectedVariant']);
const showCustomizeYourOwnButton = computed<boolean>(() => {
    return !!product.value?.variants.find (v => v.isConfigureable) && !selectedVariant.value?.isConfigureable;
});
const customizeYourOwnVariant = computed<VariantBaseViewObject>(() => {
    return product.value?.variants.find (v => v.isConfigureable)
});
// console.log("product", product.value)
// console.log("selectedVariant", selectedVariant.value)
// console.log("showCustomizeYourOwnButton", showCustomizeYourOwnButton.value)
// console.log("customizeYourOwnVariant", customizeYourOwnVariant.value)

onUpdated(() => {
    const color = props.colors.find(x => x.code === props.value);
    if (color) {
        selectedColor.value = color;
        selectedColorText.value = color.text;
    }
});

function selectVariant(variant) {
    // console.log('selectVariant',variant);
      store.dispatch("catalog/selectVariant", variant);
  }

function setIntendedColorChangeText(color: IColorOption):void {
    intendedColorChangeText.value = color.text;
}

function getColorOptionInnerStyles(color: IColorOption) {
    return color.image
        ? { backgroundImage: `url('${color.image}')`, backgroundSize: 'contain' }
        : { backgroundColor: color.code };
}

function isColorSelected(color: IColorOption) {
    const selected = color.code === props.value;
    if (selected === true) {
        selectedColor.value = color;
    }
    return selected;
}

return { __sfc: true,props, selectedColor, selectedColorText, intendedColorChangeText, product, selectedVariant, showCustomizeYourOwnButton, customizeYourOwnVariant, selectVariant, setIntendedColorChangeText, getColorOptionInnerStyles, isColorSelected }
}

})